<template>
<div class="accordion" :class="_class">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: ['type', 'toggle'],
    computed: {
        _class: function() {
            let _class = []

            if(this.toggle) {
                _class.push('accordion-toggle-'+this.toggle)
            }

            if(this.type) {
                _class.push('accordion-'+this.type)
            }

            return _class
        }
    }
}
</script>